import React, { useState, useEffect, Suspense } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { updateSubscription } from "../../../AxiosRtk/Subscription/SUBSCRIPTIONCURD";

const PaymentCancel = (props) => {
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();
  const { user } = useSelector(({ auth }) => auth);

  const history = useHistory();

  const createSubscription = (sessionId) => {
    dispatch(updateSubscription(sessionId, user));
  };

  useEffect(() => {
    if (
      props.location.search.slice(props.location.search.indexOf("=") + 1) !== ""
    ) {
      createSubscription(
        props.location.search.slice(props.location.search.indexOf("=") + 1)
      );
    } else {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "calc(100vh - 130px)" }}
      >
        <Suspense fallback={() => { }}>
          <div
            className="bg-danger rounded-circle d-flex align-items-center justify-content-center m-3"
            style={{
              width: 120,
              height: 120,
              boxShadow: "0 0 0 10px rgb(255 0 0 / 35%)",
            }}
          >
            <i className="icon-cancel display-1 text-white" />
          </div>
          <h1 className="my-3">
            {getLangTranslation(
              "SETTING_SUBSCRIPTION_PAYMENT_CANCEL",
              "Payment Cancelled"
            )}
          </h1>
          <button
            type="button"
            onClick={() => history.push("/settings")}
            id="kt_sign_in_submit"
            className="btn btn-lg btn-primary"
          >
            {getLangTranslation("Continue", "Continue")}
          </button>
        </Suspense>
      </div>
    </>
  );
};

export default PaymentCancel;
